import { Y as m } from "./TrailingNode-rLvSyRLT.js";
import { B as R, a as V, D as $, F as X, H as z, L as G, N as J, P as Q, b as W, c as Z, S as q, d as ee, T as te, e as oe, V as ne, s as re, t as ae } from "./TrailingNode-rLvSyRLT.js";
import { yCursorPlugin as p, defaultSelectionBuilder as k, redoCommand as E, undoCommand as x, yUndoPlugin as C, yUndoPluginKey as g } from "@y/prosemirror";
import * as c from "@y/y";
import { c as d, a as v } from "./BlockNoteExtension-C2X7LW-V.js";
import { PluginKey as w, Plugin as T } from "@tiptap/pm/state";
import { a2 as h, _ as L } from "./defaultBlocks-DAhNpM4s.js";
import { ae as ie, af as ce, ah as le, ag as ue, ad as de } from "./defaultBlocks-DAhNpM4s.js";
import { S as fe } from "./ShowSelection-Dz-NEase.js";
function y(e) {
  const o = e.charAt(0) === "#" ? e.substring(1, 7) : e, t = parseInt(o.substring(0, 2), 16), n = parseInt(o.substring(2, 4), 16), r = parseInt(o.substring(4, 6), 16), i = [t / 255, n / 255, r / 255].map((l) => l <= 0.03928 ? l / 12.92 : Math.pow((l + 0.055) / 1.055, 2.4));
  return 0.2126 * i[0] + 0.7152 * i[1] + 0.0722 * i[2] <= 0.179;
}
function M(e) {
  const o = document.createElement("span");
  o.classList.add("bn-collaboration-cursor__base");
  const t = document.createElement("span");
  t.setAttribute("contentedEditable", "false"), t.classList.add("bn-collaboration-cursor__caret"), t.setAttribute(
    "style",
    `background-color: ${e.color}; color: ${y(e.color) ? "white" : "black"}`
  );
  const n = document.createElement("span");
  return n.classList.add("bn-collaboration-cursor__label"), n.setAttribute(
    "style",
    `background-color: ${e.color}; color: ${y(e.color) ? "white" : "black"}`
  ), n.insertBefore(document.createTextNode(e.name), null), t.insertBefore(n, null), o.insertBefore(document.createTextNode("⁠"), null), o.insertBefore(t, null), o.insertBefore(document.createTextNode("⁠"), null), o;
}
const S = d(
  ({ options: e }) => {
    const o = /* @__PURE__ */ new Map(), t = e.provider && "awareness" in e.provider && typeof e.provider.awareness == "object" ? e.provider.awareness : void 0;
    return t && ("setLocalStateField" in t && typeof t.setLocalStateField == "function" && t.setLocalStateField("user", e.user), "on" in t && typeof t.on == "function" && e.showCursorLabels !== "always" && t.on(
      "change",
      ({
        updated: n
      }) => {
        for (const r of n) {
          const a = o.get(r);
          a && (a.element.setAttribute("data-active", ""), a.hideTimeout && clearTimeout(a.hideTimeout), o.set(r, {
            element: a.element,
            hideTimeout: setTimeout(() => {
              a.element.removeAttribute("data-active");
            }, 2e3)
          }));
        }
      }
    )), {
      key: "yCursor",
      prosemirrorPlugins: [
        t ? p(t, {
          selectionBuilder: k,
          cursorBuilder(n, r) {
            let a = o.get(r);
            if (!a) {
              const i = (e.renderCursor ?? M)(n);
              e.showCursorLabels !== "always" && (i.addEventListener("mouseenter", () => {
                const s = o.get(r);
                s.element.setAttribute("data-active", ""), s.hideTimeout && (clearTimeout(s.hideTimeout), o.set(r, {
                  element: s.element,
                  hideTimeout: void 0
                }));
              }), i.addEventListener("mouseleave", () => {
                const s = o.get(r);
                o.set(r, {
                  element: s.element,
                  hideTimeout: setTimeout(() => {
                    s.element.removeAttribute("data-active");
                  }, 2e3)
                });
              })), a = {
                element: i,
                hideTimeout: void 0
              }, o.set(r, a);
            }
            return a.element;
          }
        }) : void 0
      ].filter(Boolean),
      dependsOn: ["ySync"],
      updateUser(n) {
        t == null || t.setLocalStateField("user", n);
      }
    };
  }
), f = d(() => ({
  key: "yUndo",
  prosemirrorPlugins: [C()],
  dependsOn: ["yCursor", "ySync"],
  undoCommand: x,
  redoCommand: E
}));
function P(e, o) {
  const t = e.doc;
  if (e._item === null) {
    const n = Array.from(t.share.keys()).find(
      (r) => t.share.get(r) === e
    );
    if (n == null)
      throw new Error("type does not exist in other ydoc");
    return o.get(n, e.constructor);
  } else {
    const n = e._item, r = o.store.clients.get(n.id.client) ?? [], a = c.findIndexSS(r, n.id.clock);
    return r[a].content.type;
  }
}
const O = d(
  ({ editor: e, options: o }) => {
    let t;
    const n = v({ isForked: !1 });
    return {
      key: "yForkDoc",
      store: n,
      /**
       * Fork the Y.js document from syncing to the remote,
       * allowing modifications to the document without affecting the remote.
       * These changes can later be rolled back or applied to the remote.
       */
      fork() {
        if (t)
          return;
        const r = o.fragment;
        if (!r)
          throw new Error("No fragment to fork from");
        const a = new c.Doc();
        c.applyUpdate(a, c.encodeStateAsUpdate(r.doc));
        const i = P(r, a);
        t = {
          undoStack: g.getState(e.prosemirrorState).undoManager.undoStack,
          originalFragment: r,
          forkedFragment: i
        }, e.unregisterExtension([
          f,
          S,
          m
        ]);
        const s = {
          ...o,
          fragment: i
        };
        e.registerExtension([
          m(s),
          // No need to register the cursor plugin again, it's a local fork
          f()
        ]), n.setState({ isForked: !0 });
      },
      /**
       * Resume syncing the Y.js document to the remote
       * If `keepChanges` is true, any changes that have been made to the forked document will be applied to the original document.
       * Otherwise, the original document will be restored and the changes will be discarded.
       */
      merge({ keepChanges: r }) {
        if (!t)
          return;
        e.unregisterExtension(["ySync", "yCursor", "yUndo"]);
        const { originalFragment: a, forkedFragment: i, undoStack: s } = t;
        if (e.registerExtension([
          m(o),
          S(o),
          f()
        ]), g.getState(
          e.prosemirrorState
        ).undoManager.undoStack = s, r) {
          const l = c.encodeStateAsUpdate(
            i.doc,
            c.encodeStateVector(a.doc)
          );
          c.applyUpdate(a.doc, l, e);
        }
        t = void 0, n.setState({ isForked: !1 });
      }
    };
  }
), b = (e, o) => {
  o(e), e.forEach((t) => {
    t instanceof c.XmlElement && b(t, o);
  });
}, A = (e, o) => {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((n) => {
    n instanceof c.XmlElement && b(n, (r) => {
      if (r.nodeName === "blockContainer" && r.hasAttribute("id")) {
        const a = r.getAttribute("textColor"), i = r.getAttribute("backgroundColor"), s = {
          textColor: a === h.textColor.default ? void 0 : a,
          backgroundColor: i === h.backgroundColor.default ? void 0 : i
        };
        (s.textColor || s.backgroundColor) && t.set(r.getAttribute("id"), s);
      }
    });
  }), t.size === 0 ? !1 : (o.doc.descendants((n, r) => {
    if (n.type.name === "blockContainer" && t.has(n.attrs.id)) {
      const a = o.doc.nodeAt(r + 1);
      if (!a)
        throw new Error("No element found");
      o.setNodeMarkup(r + 1, void 0, {
        // preserve existing attributes
        ...a.attrs,
        // add the textColor and backgroundColor attributes
        ...t.get(n.attrs.id)
      });
    }
  }), !0);
}, F = [A], D = d(
  ({ options: e }) => {
    let o = !1;
    const t = new w("schemaMigration");
    return {
      key: "schemaMigration",
      prosemirrorPlugins: [
        new T({
          key: t,
          appendTransaction: (n, r, a) => {
            if (o || // If any of the transactions are not due to a yjs sync, we don't need to run the migration
            !n.some((s) => s.getMeta("y-sync$")) || // If none of the transactions result in a document change, we don't need to run the migration
            n.every((s) => !s.docChanged) || // If the fragment is still empty, we can't run the migration (since it has not yet been applied to the Y.Doc)
            !e.fragment.firstChild)
              return;
            const i = a.tr;
            for (const s of F)
              s(e.fragment, i);
            if (o = !0, !!i.docChanged)
              return i;
          }
        })
      ]
    };
  }
);
let u;
async function I() {
  return u || (u = (async () => {
    const [e, o] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), t = "default" in e ? e.default : e, n = "default" in o ? o.default : o;
    return await t.init({ data: n }), { emojiMart: t, emojiData: n };
  })(), u);
}
async function K(e, o) {
  if (!("text" in e.schema.inlineContentSchema) || e.schema.inlineContentSchema.text !== L.text)
    return [];
  const { emojiData: t, emojiMart: n } = await I();
  return (o.trim() === "" ? Object.values(t.emojis) : await n.SearchIndex.search(o)).map((a) => ({
    id: a.skins[0].native,
    onItemClick: () => e.insertInlineContent(a.skins[0].native + " ")
  }));
}
export {
  R as BlockChangeExtension,
  V as DEFAULT_LINK_PROTOCOL,
  $ as DropCursorExtension,
  ie as FilePanelExtension,
  O as ForkYDocExtension,
  X as FormattingToolbarExtension,
  z as HistoryExtension,
  G as LinkToolbarExtension,
  J as NodeSelectionKeyboardExtension,
  Q as PlaceholderExtension,
  W as PreviousBlockTypeExtension,
  D as SchemaMigration,
  fe as ShowSelectionExtension,
  Z as SideMenuExtension,
  q as SideMenuView,
  ce as SuggestionMenu,
  ee as TableHandlesExtension,
  te as TableHandlesView,
  oe as TrailingNodeExtension,
  ne as VALID_LINK_PROTOCOLS,
  S as YCursorExtension,
  m as YSyncExtension,
  f as YUndoExtension,
  le as filterSuggestionItems,
  K as getDefaultEmojiPickerItems,
  ue as getDefaultSlashMenuItems,
  de as insertOrUpdateBlockForSlashMenu,
  re as sideMenuPluginKey,
  ae as tableHandlesPluginKey
};
//# sourceMappingURL=extensions.js.map
